import { api } from '@/store/interface/apiUser'
import Vue from 'vue'

export default {
  namespaced: true,

  state: {
    user: {},
    loaded: false
  },

  getters: {
    isLoaded: state => {
      return state.loaded
    },
    user: state => {
      return state.user
    },
    avatar: state => {
      return state.user.avatar
    },
    picture: state => {
      return state.user.isAvatarUsed ? state.user.avatarPic : state.user.profilePic
    },
    getFavorites: (state, getters) => index => {
      return state.user.favorites
    },
    getEntityFav: (state) => id => {
      if (!Array.isArray(state.user.favorites)) {
        return undefined
      }

      return state.user.favorites.find(fav => fav.craft_id === id)
    }
  },

  actions: {
    async user ({ commit, state, dispatch }) {
      return  new Promise(resolve => {
        const { request, cache } = api.getUser()
        // cache.then(res => {
        //   if (res !== null) {
        //     commit('user', res)
        //     commit('loaded', true)
        //     resolve()
        //   }
        // })

        request.then(res => {
          commit('user', res)
          commit('loaded', true)
          dispatch('data/computeFav', null, { root: true } )
          resolve()
        })
      })
    },
    avatar ({ commit, state }, payload) {
      return new Promise(resolve => {
        const { request, cache } = api.updateAvatar(payload)
        request.then(res => {
          commit('user', res)
          resolve()
        })
      })
    },
    async avatarPicture ({ dispatch }, payload) {
      const { request } = await api.updateAvatarPicture(payload)
      return
    },
    async profilePicture ({ commit, dispatch }, payload) {
      await api.updateProfilePicture(payload)
      const { request } = api.getUserImage()

      request.then(res => {
        commit('user', res)
      })
      return
    },
    async update ({ dispatch }, payload) {
      await api.updateUser(payload)
      await dispatch('user')
      return
    },
    async addFav ({ dispatch }, payload) {
      await api.addFav(payload)
      await dispatch('user')
      return
    },
    async removeFav ({ dispatch, getters }, id) {
      const fav = getters.getEntityFav(id)

      await api.removeFav(fav.uid)
      await dispatch('user')
      return
    }
  },

  mutations: {
    loaded (state, payload) {
      state.loaded = payload
    },
    user (state, payload) {
      state.user = {...state.user, ...payload}
    },
    // favorites (state, payload) {
    //   state.favorites = payload
    // }
  }
}